import { Flags } from "../interfaces/Flags";

const select: Flags[] = [
    { label: 'Sim', value: 'Y' },
    { label: 'Não', value: 'N' },
];

export default select